import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useState, useRef, useEffect } from "react";

export const TopNavBarReporterPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  return (
    <div className="fixed top-0 p-2 flex justify-between bg-gray-100 border border-gray-300 border-t-0 border-x-0 w-full shadow-lg">
      <div
        className="hover:bg-gray-300 p-2 rounded-md border border-gray-300 bg-white"
        onClick={() => {
          navigate("/status");
        }}
      >
        Ontario & Quebec Status
      </div>
      <div
        className="hover:bg-gray-300 p-2 rounded-md border border-gray-300 bg-white place-self-center"
        onClick={async () => {
          setLoading(true);
          const response = await axios.get(
            process.env.NODE_ENV === "development" ? "http://localhost:3000/logout" : `${process.env.REACT_APP_PROD_URL}/logout`,
            { withCredentials: true }
          );
          if (response.data.isLoggedOut) {
            navigate("/login");
          } else {
            console.log("Unable to log out");
            setLoading(false);
          }
        }}
      >
        {!loading && <div>Logout</div>}
        {loading && (
          <div role="status" className="">
            <svg
              aria-hidden="true"
              className="w-5 h-5 text-gray-200 animate-spin fill-gray-600 "
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill"
              />
            </svg>
            <span className="sr-only">Loading...</span>
          </div>
        )}
      </div>
    </div>
  );
};

//TODO rename to TopNavBar
export const TopNavBarStatusPage = ({ modalCallback, fixed, isStatusPage }) => {
  const [loading, setLoading] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const menuDropdownRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleDocumentClick = (event) => {
      if (menuDropdownRef.current && !menuDropdownRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleDocumentClick);
    return () => {
      document.removeEventListener("mousedown", handleDocumentClick);
    };
  }, [menuOpen]);

  return (
    <div className={`${fixed ? "fixed top-0" : ""} p-2 flex justify-between bg-gray-100 border-2 border-gray-300 border-t-0 border-x-0 w-full shadow-lg`}>
      <div
        className="hover:bg-gray-300 p-2 rounded-md border border-gray-300 bg-white"
        onClick={() => {
          setMenuOpen((v) => !v);
        }}
      >
        Menu
      </div>

      {menuOpen && (
        <div className="absolute left-2 top-2 w-40 bg-white border border-gray-300 rounded-md shadow-2xl z-50" ref={menuDropdownRef}>
          {isStatusPage === true ? (
            <div
              className="block px-4 py-2 text-gray-800 hover:bg-blue-500 hover:text-white rounded-t-md"
              onClick={() => {
                modalCallback();
                setMenuOpen(false);
              }}
            >
              Status Summary
            </div>
          ) : (
            <div
              className="block px-4 py-2 text-gray-800 hover:bg-blue-500 hover:text-white rounded-t-md"
              onClick={() => {
                navigate("/status");
              }}
            >
              Status Page
            </div>
          )}

          <div
            className="block px-4 py-2 text-gray-800 hover:bg-blue-500 hover:text-white"
            onClick={() => {
              navigate("/");
            }}
          >
            Reporter Page
          </div>
          <div
            className="block px-4 py-2 text-gray-800 hover:bg-blue-500 hover:text-white"
            onClick={() => {
              navigate("/register");
            }}
          >
            Register User
          </div>
          <div
            className="block px-4 py-2 text-gray-800 hover:bg-blue-500 hover:text-white rounded-b-md"
            onClick={() => {
              navigate("/admin");
            }}
          >
            Admin Page
          </div>
        </div>
      )}

      <div
        className="hover:bg-gray-300 p-2 rounded-md border border-gray-300 bg-white"
        onClick={async () => {
          setLoading(true);
          const response = await axios.get(
            process.env.NODE_ENV === "development" ? "http://localhost:3000/logout" : `${process.env.REACT_APP_PROD_URL}/logout`,
            { withCredentials: true }
          );
          if (response.data.isLoggedOut) {
            navigate("/login");
          } else {
            console.log("Unable to log out");
            setLoading(false);
          }
        }}
      >
        {!loading && <div>Logout</div>}
        {loading && (
          <div role="status" className="">
            <svg
              aria-hidden="true"
              className="w-5 h-5 text-gray-200 animate-spin fill-gray-600 "
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill"
              />
            </svg>
            <span className="sr-only">Loading...</span>
          </div>
        )}
      </div>
    </div>
  );
};
